<template>
  <b-modal
    id="new-form-modal"
    ref="new-form-modal"
    centered
    title="Create New Form"
    ok-title="Save Changes"
    cancel-variant="outline-secondary"
    no-close-on-backdrop
    @hidden="resetModal"
    @ok="create"
  >
    <b-overlay
      id="overlay-background"
      :show="isLoading"
      variant="white"
      opacity="1"
      rounded="sm"
    >
      <validation-observer
        ref="createNewFormRules"
        tag="form"
      >
        <b-row>
          <b-col
            cols="12"
          >
            <b-form-group
              label="Name"
            >
              <validation-provider
                #default="{ errors }"
                name="Name"
                rules="required"
              >
                <b-form-input
                  v-model="name"
                  placeholder="Name here"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BOverlay,
} from 'bootstrap-vue'

import useFormsSetting from '@/views/admin/forms/useFormsSetting'

export default {
  name: 'NewFormModal',
  components: {
    ValidationProvider,
    ValidationObserver,

    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BOverlay,
  },
  props: {
    folderId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      name: '',
      required,
    }
  },
  setup() {
    const {
      postForm,
    } = useFormsSetting()

    return {
      postForm,
    }
  },
  methods: {
    resetModal() {
      this.name = ''
    },
    create(bvModalEvt) {
      bvModalEvt.preventDefault()

      return new Promise(() => {
        this.$refs.createNewFormRules.validate().then(success => {
          if (success) {
            const queryParams = {
              name: this.name,
            }

            if (this.folderId) queryParams.folder_id = this.folderId

            this.postForm(queryParams).then(() => {
              this.$emit('refetchData')
              this.$bvModal.hide('new-form-modal')
            })
          }
        })
      })
    },
  },
}
</script>
